import styled from "styled-components";

export const IconPermissionWrapper = styled.div`
  
`;

export const ContentPermissionWrapper = styled.div`
  .fui-Text {
    font-size: 12px;
  }
`;